import { Methods as JobSearchListRequestType } from '@doda/api-client/aspida/api/v1/jobs';
import { JobListResponse } from '@doda/api-client/aspida/@types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IncomingHttpHeaders } from 'http';
import { getJobSearchList } from './getJobSearchList';

/**
 * 求人一覧取得処理
 * @param params
 * @param offset
 * @param headers HTTPヘッダー
 * @param useV2JobSearchListApi
 * @returns 求人一覧
 */
export const getJobListForTrend = async (
  params: JobSearchListRequestType['get']['query'],
  offset: number,
  useV2JobSearchListApi: boolean,
  headers?: IncomingHttpHeaders
) => {
  return getJobSearchList({
    query: {
      ...params,
      limit: 20,
      offset,
    },
    headers,
    useV2JobSearchListApi,
  });
};

/**
 * 共通求人一覧取得処理
 * @param params
 * @param offset
 * @param useV2JobSearchListApi
 * @returns 求人一覧
 */
const getJobListForTrendCommon = async (
  params: JobSearchListRequestType['get']['query'],
  offset: number,
  useV2JobSearchListApi: boolean
) => {
  try {
    const jobSearchList = await getJobListForTrend(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  } catch {
    throw new Error('求人一覧requirementsの取得に失敗しました');
  }
};

/**
 * エラーレスポンス
 * @param message エラーメッセージ
 * @param redirect リダイレクト要否
 */
export interface RejectedValue {
  message: string;
  redirect: boolean;
}

export const getJobListForTrendRequirements = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
    useV2JobSearchListApi: boolean;
  }
>(
  'getJobListForTrend/getJobListForTrendRequirements',
  async ({ params, offset, useV2JobSearchListApi }) => {
    const jobSearchList = await getJobListForTrendCommon(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  }
);

export const getJobListForTrendWorkplaceEnvironment = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
    useV2JobSearchListApi: boolean;
  }
>(
  'getJobListForTrend/getJobListForTrendWorkplaceEnvironment',
  async ({ params, offset, useV2JobSearchListApi }) => {
    const jobSearchList = await getJobListForTrendCommon(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  }
);

export const getJobListForTrendIncome = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
    useV2JobSearchListApi: boolean;
  }
>(
  'getJobListForTrend/getJobListForTrendIncome',
  async ({ params, offset, useV2JobSearchListApi }) => {
    const jobSearchList = await getJobListForTrendCommon(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  }
);

export const getJobListForTrendHolidayAndWayOfWorking = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
    useV2JobSearchListApi: boolean;
  }
>(
  'getJobListForTrend/getJobListForTrendHolidayAndWayOfWorking',
  async ({ params, offset, useV2JobSearchListApi }) => {
    const jobSearchList = await getJobListForTrendCommon(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  }
);

export const getJobListForTrendEmployeeAverageAge = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
    useV2JobSearchListApi: boolean;
  }
>(
  'getJobListForTrend/getJobListForTrendEmployeeAverageAge',
  async ({ params, offset, useV2JobSearchListApi }) => {
    const jobSearchList = await getJobListForTrendCommon(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  }
);

export const getJobListForTrendEmploymentStatus = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
    useV2JobSearchListApi: boolean;
  }
>(
  'getJobListForTrend/getJobListForTrendEmploymentStatus',
  async ({ params, offset, useV2JobSearchListApi }) => {
    const jobSearchList = await getJobListForTrendCommon(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  }
);

export const getJobListForTrendWelfareBenefits = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
    useV2JobSearchListApi: boolean;
  }
>(
  'getJobListForTrend/getJobListForTrendWelfareBenefits',
  async ({ params, offset, useV2JobSearchListApi }) => {
    const jobSearchList = await getJobListForTrendCommon(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  }
);

export const getJobListForTrendLanguageAndPositions = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
    useV2JobSearchListApi: boolean;
  }
>(
  'getJobListForTrend/getJobListForTrendLanguageAndPositions',
  async ({ params, offset, useV2JobSearchListApi }) => {
    const jobSearchList = await getJobListForTrendCommon(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  }
);

export const getJobListForTrendEstablish = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
    useV2JobSearchListApi: boolean;
  }
>(
  'getJobListForTrend/getJobListForTrendEstablish',
  async ({ params, offset, useV2JobSearchListApi }) => {
    const jobSearchList = await getJobListForTrendCommon(
      params,
      offset,
      useV2JobSearchListApi
    );
    return jobSearchList;
  }
);
